import React, { ReactElement } from 'react';
// import LazyLoad from 'react-lazyload';

interface ILazyLoadColumn {
  children: React.ReactElement;
  lazy?: boolean;
}
const LazyLoadColumn = function(props: ILazyLoadColumn) {
  // if (props.lazy === false) {
    return props.children;
  // }
  // return (
  //   <LazyLoad
  //     height={'100%'}
  //     // overflow={true}
  //     offset={400}
  //     once
  //
  //     // 如果发现没有效果，请加上这个container
  //     // scrollContainer={
  //     //   document.querySelector(".decorate-container") as HTMLDivElement
  //     // }
  //   >
  //     {props.children}
  //   </LazyLoad>
  // );
};

export default LazyLoadColumn;
